import {Injectable, Optional} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {CmsPage} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  uid: string,
  uuid: string,
  title: string,
  template: string,
  typeCode: string,
  name: string,
  contentSlots: {
    contentSlot: IContentSlot[]
  }
}

interface IContentSlot {
  slotId: string,
  slotUuid: string,
  position: string,
  name: string,
  slotShared: false,
  components: {
    component: IBaseComponent[]
  }
}

interface IBaseComponent {
  uid: string,
  uuid: string,
  typeCode: string,
  modifiedTime: string,
  name: string,
  container: string,
  query?: string,
  node?: {
    container?: boolean,
    uid?: string,
    name?: string,
    links?: string,
    title?: string,
    uuid?: string,
    typeCode?: string,
  },
  external?: boolean,
  icon?: string,
  linkName?: string,
  url?: string,
  target?: boolean,
  linkRe?: {
    container?: boolean,
    uid?: string,
    external?: boolean,
    name?: string,
    icon?: string,
    uuid?: string,
    linkName?: string,
    url?: string,
    typeCode?: string,
    target?: boolean
  },
  links?: string,
  title?: string
}

type SearchResponse = IResponseItem[];

@Injectable({
  providedIn: 'root'
})
export class CmsPageConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string

  private route = '/cms/pages';

  private cmsRoute = '/cms/components/';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite
  }

  private static transformFromApi(response: IResponseItem): Observable<CmsPage> {
    return of(
      {
        ...response,
        id: response.uid
      }
    )
  }

  loadPageByIdOrTicket(
    pageId: string,
    isCmsTicket: boolean,
    cmsTicketId?: string
  ): Observable<CmsPage> {
    let options = 'pageLabelOrId=' + pageId;
    if (isCmsTicket) {
      options = 'cmsTicketId=' + cmsTicketId;
    }
    return this.http.get<IResponseItem>(this.getManyUrl() + '?' + options).pipe(
      switchMap(
        (response: IResponseItem) => CmsPageConnectors.transformFromApi(response)
      ),
      catchError(error => throwError(error))
    );
  }

  loadPageByProductCode(code: string): Observable<CmsPage> {
    return this.http.get<IResponseItem>(this.getManyUrl() + '?code=' + code + '&pageType=ProductPage').pipe(
      switchMap(
        (response: IResponseItem) => CmsPageConnectors.transformFromApi(response)
      ),
      catchError(error => throwError(error))
    )
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route;
  }

  protected getOneUrl(componentId: string): string {
    return this._rootUrl + this._baseSite + this.cmsRoute + componentId;
  }
}
